<template lang='pug'>
    v-main
      v-container(fluid)
        v-flex
          v-card
            v-toolbar(class="elevation-0" color='white')
              v-toolbar-title(v-model="title") {{ title }}
              v-spacer
              v-btn(v-if="createPvButton" id="btnCreatePV" class='blue-secondary elevation-0'  @click="$router.push('/create-pv')") Create PV
              v-btn(v-if="!createPvButton" id="btnCreateMemoDialog" class='blue-secondary elevation-0'  @click="reqTypeDialog = true") Create
              v-dialog( width="420px" style="overflow:hidden; " v-model="reqTypeDialog" persistent)
                v-card
                  h1(style="background: #E0E0E0; padding: 0.5rem; padding-left:1rem; font-size: large;") Select Request
                  div(style="padding: 0rem 1rem 0 1rem;")
                    select( required id="crMemoSlec" placeholder="Select Type" v-model="createMemoReqType" style="outline:none;border-bottom: 1px solid;width: 100%;margin-bottom: 1rem;padding: 0.1rem 0.5rem; ; margin: 2rem 0")
                      option(value='' hidden selected="true" disabled="true") Select Type
                      option(id='btnSelectGeneral' value='General') General Request
                      option(id='btnselectPayment' value='Payment') Payment Request
                      option(id='btnselectAnnouncement' value='Announcement') IM Announcement
        
                    v-card-actions(style="padding-top:0; justify-content: right; padding-bottom:1.4rem")
                      v-btn(depressed, large, id='btnSelectCreateMemoTypeCancle' style="color:#000; backgound:#f5f5f5; margin-right:.3rem"  @click="reqTypeDialog = false; createMemoReqType = ''") Cancel
                      v-btn(depressed, large, id='btnSelectCreateMemoTypeCreate' color="primary" @click="createMemo(); reqTypeDialog = false; ; createMemoReqType = ''") Create
              
            v-divider
            div(style="margin: 0.5rem; font-size: 14px; ")
              span Information : &nbsp;&nbsp;
              v-icon(small color="blue") remove_red_eye 
              span &nbsp; View Detail &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title !== 'Approval Page PV'" color="green") edit 
              span(v-if="title !== 'Approval Page PV'") &nbsp; Edit &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title == 'Approval Page'" color="blue") assignment_turned_in 
              span(v-if="title == 'Approval Page'") &nbsp; Approval &nbsp;&nbsp;&nbsp;
              v-icon(
                small
                v-if="showApprovalLegend"
                :color="needApprovalLegendColor"
              ) assignment_turned_in
              span(v-if="showApprovalLegend") &nbsp; Approval &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title !== 'Approval Page PV'" color="red") cancel
              span(v-if="title !== 'Approval Page PV'") &nbsp; Withdraw &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title != 'Approval Page' && (enableCopyPVFeature || !['My Request PV', 'Approval Page PV'].includes(title))" color="orange") filter_none
              span(v-if="title != 'Approval Page' && (enableCopyPVFeature || !['My Request PV', 'Approval Page PV'].includes(title))") &nbsp; Copy IM &nbsp;&nbsp;&nbsp;
              v-icon(small color="green") cloud_download 
              span &nbsp; Download File &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title != 'Approval Page' && title !== 'Approval Page PV'" color="orange") send 
              span(v-if="title != 'Approval Page' && title !== 'Approval Page PV'") &nbsp; Resend Approval &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title != 'Approval Page' && title !== 'Approval Page PV'" color="blue") mdi-share-circle
              span(v-if="title != 'Approval Page' && title !== 'Approval Page PV'") &nbsp; Share URL &nbsp;&nbsp;&nbsp;
            v-divider
            v-toolbar(class="elevation-0 mt-2 mb-4" color='white')
              v-select(
                label="Business Unit" 
                :items="dataBisnisUnit" 
                item-value="value" 
                v-model="bisnisUnit" 
                hide-details 
                class='hidden-sm-and-down col-3 pl-0'
                multiple
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggle") 
                    v-list-item-action
                      v-icon(:color="bisnisUnit.length > 0 ? 'indigo darken-4' : ''") {{ iconX }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="bisnisUnit.length == 1"
                    close
                    @click:close="remove(bisnisUnit, 'bisnis unit')"
                  )
                    span {{ item.text | truncate(20, '...') }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('bisnis unit')"
                  )
                    span {{ bisnisUnit.length }} Business Unit
              span(class="pr-1" v-if="title != 'My Request PV' && title != 'Approval Page PV'")
              v-select(
                v-if="title != 'My Request PV' && title != 'Approval Page PV'"
                label="IM Type"
                v-model="filterImType"
                hide-details 
                multiple
                :items="dataImType" 
                item-value="value" 
                class="hidden-sm-and-down col-2 pl-0"
                :disabled="title == 'My Request PV'"
                style="min-width: 200px;"
              )
                template(v-slot:prepend-item v-if="title != 'My Request PV'")
                  v-list-item(ripple @mousedown.prevent @click="toggleImType") 
                    v-list-item-action
                      v-icon(:color="filterImType.length > 0 ? 'indigo darken-4' : ''") {{ iconXimType }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="filterImType.length == 1"
                    :close="title != 'My Request PV'"
                    @click:close="remove(filterImType, 'imType')"
                    style="white-space: nowrap;"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    :close="title != 'My Request PV'"
                    @click:close="removeAll('imType')"
                  )
                    span {{ filterImType.length }} Type

              span(class="pr-1")
              v-select(
                multiple 
                label="Status" 
                hide-details 
                v-model="e3" 
                :items="dataStatus" 
                item-value="value"
                item-text="text"
                class="hidden-sm-and-down col-2 pl-0"
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggleStatus") 
                    v-list-item-action
                      v-icon(:color="e3.length > 0 ? 'indigo darken-4' : ''") {{ iconXStatus }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="e3.length == 1"
                    close
                    @click:close="remove(e3, 'status')"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('status')"
                  )
                    span {{ e3.length }} Status

              span(class="pr-1" v-if="title != 'My Request PV' && title != 'Approval Page PV'")
              v-select(
                v-if="title != 'My Request PV' && title != 'Approval Page PV'"
                style="padding-bottom: 0.5rem;"
                
                multiple 
                label="Category" 
                hide-details 
                v-model="category" 
                :items="dataCategory" 
                
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggleCategory") 
                    v-list-item-action
                      v-icon(:color="e3.length > 0 ? 'indigo darken-4' : ''") {{ iconXCategory }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="category.length == 1"
                    close
                    @click:close="remove(category, 'category')"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('category')"
                  )
                    span {{ category.length }} Category

              v-text-field(flat append-icon='search' placeholder='Keyword (optional)' v-model='keyword' hide-details class='hidden-sm-and-down col-3')

            v-divider
            v-card-text(class='pa-0')
              v-data-table.elevation-1(
                :headers="title === 'My Request PV' ? im.headers : (filterImType == 'General' ? im.headers : im.paymentHeaders)"
                :items="im.items"
                :page.sync="page"
                :options.sync="options"
                :server-items-length="im.jumlah"
                :loading="loading"
                loading-text="Loading... Please wait"
                item-key='_id'
                :sort-desc.sync="im.imDate"
                multi-sortBy
                :single-expand="true"
                :expanded.sync='expanded'
                :search='keyword'
              )

                template(v-slot:item.imStatus='{ item }')
                  template(v-if="item.imWorkflow.length > 0")
                    v-chip(
                      v-if="item.imWorkflow && item.imStatus === 3"
                      label
                      small
                      :color="i18n.status[item.imStatus].color"
                      style="width:100%;justify-content:space-evenly"
                      text-color="black"
                    ) Need Review
                    v-chip(
                      v-else
                      label
                      small
                      :color="getStatusChipColor(item)"
                      style="width:100%;justify-content:space-evenly"
                      text-color="black"
                    ) {{ item.imStatusLabel }}

                  template(v-else)
                    v-chip(:color="getStatusChipColor(item)")
                    | {{ item.imStatusLabel }}

                //- template(v-slot:item.imStatus='{ item }')
                //-   v-chip(:color="i18n.status[item.imStatus].color")
                //-     | {{ i18n.status[item.imStatus].name }}

                template(v-slot:item.imDate='{ item }')
                    | {{ getUTC7Date(item.imDate) }}
                 
                template(v-slot:item.actions='{ item }')
                  div(class="d-flex")
                    div
                      IMViewPV(
                        v-if="item.imType == 8"
                        :imItems="item"
                        :dialogType="viewDialogType"
                        :needReviewForUser="item.imStatus === 3 && isMyNeedReview(item.imReturn)"
                        :needApprovalForUser="isNeedApprovalForUser(item)"
                      )
                      IMView(v-else :imItems="item" :dialogType="viewDialogType" :currencyConfigs="currencyConfigs")

                      v-icon.mr-2(:id="'loginActionCopyMemo_' + item._id" v-if="item.imStatus==7" title="Copy"  small=' ' color="orange" @click='')
                        | filter_none

                      router-link(v-if="currentUser && listType !== 'approval' && [1,3].includes(item.imStatus) && isReviewer(item.imWorkflow, currentUser)" :to='{ name: getEditRouteName(item), params: {id: item._id}}')
                        v-icon(id="loginActionEditMemo" small class='mr-2' title='Edit' color="green") edit

                      //- router-link(v-else-if="listType === 'approval' && item.imStatus == 2 && item.imStatusLabel === i18n.status[9].name" :to='{ name: "Edit Memo", params: {id: item._id}}')
                      //-   v-icon(small class='mr-2' title='Edit' color="green") edit

                      router-link(v-else-if="currentUser && listType === 'approval' && item.imStatus == 3 && isReviewer(item.imWorkflow, currentUser) && isMyNeedReview(item.imReturn)" :to='{ name: getEditRouteName(item), params: {id: item._id}}')
                        v-icon(id="loginActionEditMemo" small class='mr-2' title='Edit' color="green") edit


                      v-icon.mr-2(id="loginActionDownloadAttacment" v-if="item.imFileLampiran && item.imFileLampiran.length > 0" title="Download Attachment Files"  small='' color="green darken-1" @click='download(item.imNo)')
                        | cloud_download


                      ApprovalDialog(
                        :imItems="item"
                        v-if="(title == 'Approval Page' || title == 'Approval Page PV') && isNeedApprovalStatus(item)"
                      )
                      ApprovalDialog(
                        v-if="currentUser && title == 'Approval Page' && item.imStatus == 3 && isReviewer(item.imWorkflow, currentUser) && isMyNeedReview(item.imReturn)" 
                        :imItems="item"
                      )
                    

                      WithdrawDialogPV(
                        small 
                        class='mr-2'
                        v-if="listType === 'user' && [1,2,3].includes(item.imStatus)" 
                        :imId="item._id"
                        :im="item"
                      )
                      WithdrawDialogPV(
                        small 
                        class='mr-2'
                        v-else-if="currentUser && item.imStatus == 3 && isReviewer(item.imWorkflow, currentUser) && isMyNeedReview(item.imReturn)" 
                        :imId="item._id" 
                        :type="item.imType"
                        :im="item"
                        creator
                      )

                      ResendNotif(
                        :imNo="item.imNo"
                        v-if="['My IM Request', 'My Request PV'].includes(title) && [2,3].includes(item.imStatus)"
                      )
                      
                      //- Use CopyIMPV for Payment Voucher (imType 8)
                      CopyIMPV(
                        class='mr-2'
                        :imNo="item._id"
                        v-if="item.imType == 8 && ['My IM Request', 'My Request PV'].includes(title) && item.imStatus != 1 && (enableCopyPVFeature || !['My Request PV', 'Approval Page PV'].includes(title))"
                      )
                      
                      //- Use CopyIM for other imemo types
                      CopyIM(
                        class='mr-2'
                        :imNo="item._id"
                        :imType="item.imType"
                        v-if="item.imType != 8 && ['My IM Request', 'My Request PV'].includes(title) && item.imStatus != 1"
                      )

                      ShareURLDialog(
                        class='ml-2'
                        :im="item"
                        v-if="['My IM Request', 'My Request PV'].includes(title) && item.imStatus == 2 "
                      )

                      ShareURLDialog(
                        class='ml-2'
                        :im="item"
                        v-if="['My IM Request', 'My Request PV'].includes(title) && item.imStatus == 3 &&  !isMyNeedReview(item.imReturn)"
                      )

                    div(class="ml-auto")
                      v-icon(title="Timeline" small='' right color="dark" @click="clickColumn(item)")
                        | expand_more 
                
                template(v-slot:expanded-item='{ headers, item}' item-key="item")
                    td(:colspan='headers.length')
                      v-card.mt-5.mb-5
                        v-card-title(class="blue-secondary")
                          v-icon.mr-2.white--text timeline 
                          span(style="font-size:20px;") Approval Timeline
                        v-card-text.py-0
                          v-timeline(dense v-if="item.imWorkflow.length > 0")
                            v-timeline-item(icon='edit' color='teal accent-3' right="" )
                                v-card.elevation-2 
                                    v-card-text(v-if="item.imReSubmitedDate && item.imReSubmitedDate != null && item.imStatus == 3")
                                      | {{ getUTC7Date(item.imDate) }} - {{item.imStatus == 3 && item.imUser && (getReviewer(item).id == item.imUser.id) ? 'Need Reviewed' : 'Submited'}} by {{ item.imUser ? (item.imUseAlias ? item.imUser.alias : item.imUser.name) : '-' }}  
                                    v-card-text(v-else-if="item.imReSubmitedDate && item.imReSubmitedDate != null") {{ getUTC7Date(item.imReSubmitedDate) }} - ReSubmited by {{ item.imUser ? (item.imUseAlias ? item.imUser.alias : item.imUser.name) : '-' }}
                                    v-card-text(v-else)
                                      | {{ getUTC7Date(item.imDate) }} - {{item.imStatus == 3 && item.imUser && (getReviewer(item).id == item.imUser.id) ? 'Need Reviewed' : 'Submited'}} by {{ item.imUser ? (item.imUseAlias ? item.imUser.alias : item.imUser.name) : '-' }}  
                            
                            v-timeline-item(
                              v-for="(data, i) in item.imWorkflow"
                              :color="getStatus(data, 'status', item.imWorkflow)"
                              :icon="getStatus(data, 'icon', item.imWorkflow)" 
                              :key="i"
                            )
                                template(v-slot:opposite='' )

                                v-card.elevation-2
                                    v-card-text

                                      span(v-if="data.date") {{ getUTC7Date(data.date) }} -&nbsp;

                                      template(v-if="data.status == 5")
                                        span {{ i18n.status[data.status].name }} 
                                        span(v-if="data.user || data.name || data.alias") by {{ getWithdrawDisplayName(item, data) }}
                                        span(v-if="data.position")  ({{ data.position }})
                                        div(v-if="data.comment")
                                          div Comment: 
                                          div {{ data.comment }}
                                        //- span(v-if="data.status == 3 || data.status == 7") &nbsp;

                                      
                                      template(v-else-if="data.status != 9")
                                        span(v-if="data.status != 6 && data.status!=null" ) {{ i18n.status[data.status].name }} by 
                                        span(v-if="data.status == 13" ) {{ i18n.status[data.status].name }} by 
                                        span(v-if="item.imStatus == 3 && data.status == 6 && data.date " ) {{ i18n.status[data.status].name }} by 

                                      span(v-if="data.status != 5") {{ item.imUseAlias ? data.alias : data.name }} {{ item.imHideTitle ? '' : data.position ? "(" + data.position + ")" : '' }}

                                      span(v-if="data.status == 9 && item.imStatus != 5")  - {{ i18n.status[data.status].name }}

                                      template(v-if="![5,8].includes(item.imStatus)")
                                        span(v-if="data.status == null || data.status == 6 && !data.hasOwnProperty('date') || data.status == 6 && data.date == null")  - waiting

                                      template(v-if="item.imStatus != 5")
                                        v-card {{ (data.comment !== null && data.comment !== '' && data.comment !== undefined) ? 'Comment : '+data.comment : '' }}

                                      
                template(v-slot:no-data)
                  div.pa-15 
                    img(src="../assets/icon/empty.png")
                    div(class="empty__title mt-1") Data not found
                    div(class="empty__subtitle") Data is empty or Try adjusting your filters.                    
                                      

</template>
<style scoped>
.v-badge__badge {
  width: auto;
  border-radius: 12px;
  padding: 5px;
}
</style>

<script>
//import io from "socket.io-client";

import axios from "axios";
import * as i18n from "../data/i18n.json";
import IMView from "@/components/IMView.vue";
import IMViewPV from "@/components/IMViewPV.vue";
import ProposalView from "@/components/ProposalView.vue";
import modal from "@/components/IMModal.vue";
import ApprovalDialog from "@/components/ApprovalDialog.vue";
import WithdrawDialogPV from "@/components/WithdrawDialogPV.vue";
import PiprTrack from "@/components/PiprTrack.vue";
import ChangeManagementNotif from "@/components/ChangeManagementNotif.vue";
import ResendNotif from "@/components/ResendNotif.vue";
import ShareURLDialog from "@/components/ShareURLDialog.vue";
import CopyIM from "@/components/CopyIM.vue";
import CopyIMPV from "@/components/CopyIMPV.vue";
import { mapState, mapMutations  } from "vuex";
export default {
  name: "IMListPV",
  components: {
    IMView,
    IMViewPV,
    ProposalView,
    ApprovalDialog,
    WithdrawDialogPV,
    PiprTrack,
    modal,
    ChangeManagementNotif,
    ResendNotif,
    ShareURLDialog,
    CopyIM,
    CopyIMPV
  },
  props: {
    title: String,
    listType: String,
    dialogType: {
      type: String,
      default: "",
    },
    im: Object,
    header:Array,
    createPvButton: Boolean,
    isPV: Boolean
  },
  data() {
    return {
      // Toggle this to show/hide Copy feature for Payment Voucher pages
      // Set to true to enable, false to disable
      enableCopyPVFeature: false,
      filterImType:[],
      createMemoReqType:"",
      reqTypeDialog: false,
      exportFilename: "",
      memoInRange: [],
      memoInRangeField: {
        "IM Number": "imNo",
        "Creator": "imUser.alias",
        "IM Date": "imDate",
        "Subject": "imPerihal",
        "BU": "imOrganization.name",
        "Status": "Stat",
        "Approver": "Appvs",
        "Tanggal Approved": "AppvDates"
      },
      currencyConfigs:{},
      menu: false,
      exportDates: "",
      exportDialog: false,
      selectAllBUApproval: true,
      itemsPerPage: 10,
      page:1,
      i18n: i18n.default,
      dialog: false,
      e1: "",
      e2: "",
      e3: "",
      e6: 0,
      keyword: "",
      request:null,
      options:{
        sortBy: ['imDate'],
        sortDesc: [true]
      },
      status_request: [
        { text: "Draft", value: 1 },
        { text: "On Approval", value: 2 },
        { text: "Need Review", value: 3 },
        { text: "Rejected", value: 8 },
        { text: "Fully Approved", value: 4 },
        { text: "Withdraw", value: 5 }
      ],
      status_approval: [
        { text: "Need Approval", value: 9 },
        { text: "On Approval", value: 2 },
        { text: "Need Review", value: 3 },
        { text: "Rejected", value: 8 },
        { text: "Fully Approved", value: 4 },
        { text: "Withdraw", value: 5 }
      ],
      //socket: io.connect(this.$store.state.API_URL),
      imStat: "",
      wizardType: null,
      loading: false,
      dataImType: [
        { text: "General", value: 5 },
        { text: "Payment", value: 6 },
        { text: "Announcement", value: 7 },
        { text: "Payment Voucher", value: 8 },
      ],
      bisnis_unit: [],
      bisnisUnit: '',
      bisnis_unit_approval: [],
      expanded:[],
      dataCategory: i18n.category,
      category: "",
      loadingBU: false,
      buLoaded: false
    };
  },
  async mounted() {
    // this.group = this.$store.state.isImGroup ? this.group : 'nongroup';
    await this.getBisnisUnit()
    // Initialize filterImType for My Request PV
    if (this.title == "My Request PV") {
      this.filterImType = [8];
      // Ensure e3 is an empty array for My Request PV (not pre-filled)
      if (!Array.isArray(this.e3) || this.e3.length === 0) {
        this.e3 = [];
      }
    }
    // Force PV type on Approval Page PV so it filters to Payment Voucher
    if (this.title == "Approval Page PV") {
      this.filterImType = [8];
    }
    // Pre-select approval statuses once for approval pages
    if (
      (this.title === "Approval Page" || this.title === "Approval Page PV") &&
      (!Array.isArray(this.e3) || this.e3.length === 0 || this.e3 === "")
    ) {
      // For Approval Page PV, only pre-select "Need Approval" (9)
      // For regular Approval Page, pre-select both "Need Review" (3) and "Need Approval" (9)
      this.e3 = this.title === "Approval Page PV" ? [9] : [3, 9];
    }
  },
  watch: {
    options(val){
        this.itemsPerPage = val.itemsPerPage
        this.getOptions()
    },

    keyword() {
      // this.getPagination();
      this.getOptions()
    },
    bisnisUnit() {
      this.page=1
      // this.getPagination();
      this.getOptions()
    },
    filterImType() {
      this.page=1
      // this.category = []
      if (this.$route.name == "My Approval" && this.title != "My Request PV") this.e3 = [3,9]
      // else this.e3 = []
      this.getOptions()
    },
    e3() {
      this.page=1
      // this.getPagination();
      this.getOptions()
    },
    category() {
      this.page=1
      this.getOptions()
    },
    // Watch for user data availability and reload business units when it becomes available
    currentUser: {
      handler(newVal, oldVal) {
        // Only trigger for PV pages
        if (this.title != 'My Request PV' && this.title != 'Approval Page PV') {
          return;
        }
        
        // Trigger if user data becomes available (was null/undefined, now has value)
        // OR if user data exists but business units are still empty
        const userDataAvailable = newVal && newVal._id;
        const wasNotAvailable = !oldVal || !oldVal._id;
        const buListEmpty = this.bisnis_unit.length === 0 && this.bisnis_unit_approval.length === 0;
        
        if (userDataAvailable && (wasNotAvailable || (!this.buLoaded && buListEmpty))) {
          // Only reload if not currently loading
          if (!this.loadingBU) {
            this.getBisnisUnit();
          }
        }
      },
      immediate: false
    }
  },
  beforeDestroy(){
    switch(this.title){
      case 'Approval Page':
        this.$store.state.dataReqApproval.data = [];
        this.$store.state.dataReqApproval.jumlah = 0
        break;
      case 'My IM Request':
      case 'My Request PV':
        this.$store.state.dataRequests.data = [];
        this.$store.state.dataRequests.jumlah = 0;
        break;
    }
  },
  computed: {
    ...mapState(["dataUsers", "API_URL"]),
    currentUser() {
      return (this.$store.state.dataUsers && this.$store.state.dataUsers.user) || null;
    },
    search2: function() {
      return this.bisnisUnit + "_" + this.e3 + "_" + this.keyword;
    },
    dateRangeText () {
        return this.exportDates.join(' ~ ')
      },
    filteredData: function() {
      let tujuan = this.tujuan_req;
      return tujuan.filter(x => x.dep == this.e1);
    },
    dataTipe() {
      let result = [{ text: "All", value: "" }];
      for (const val in this.i18n.imType) {
        result.push({
          text: this.i18n.imType[val],
          value: val
        });
      }
      return result;
    },
    showApprovalLegend() {
      return this.title === 'Approval Page PV';
    },
    dataStatus() {
      if (this.title == 'My IM Request' || this.title == 'My Request PV') {
        return this.status_request;
      } else if (this.title == 'Approval Page PV') {
        // For Approval Page PV, exclude "Need Review" (value: 3) from the status dropdown
        return this.status_approval.filter(status => status.value !== 3);
      } else {
        return this.status_approval;
      }
    },
    viewDialogType() {
      if (this.title === 'Approval Page PV') return 'spv';
      return this.dialogType || '';
    },
    needApprovalLegendColor() {
      const status = this.i18n.status && this.i18n.status[9];
      return (status && status.color) || 'blue';
    },
    dataBisnisUnit() {
      function compare( a, b ) {
        if ( a.text < b.text ){
          return -1;
        }
        if ( a.text > b.text ){
          return 1;
        }
        return 0;
      }
      if (['My IM Request', 'My Request PV', 'Export List IM'].includes(this.title)) {
        // Filter out invalid entries and ensure all have valid value and text
        const filtered = this.bisnis_unit
          .filter(item => item && item.value && item.text)
          .filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          .sort( compare );
        return filtered;
      } else {
        const result = this.bisnis_unit_approval
          .filter(item => item && item.value && item.text)
          .filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          .sort( compare );
        // Remove "Other" option for Approval Page PV
        if (this.title !== 'Approval Page PV') {
          result.push({ text: "Other", value: "other" })
        }
        return result
      }
    },

    selectAllBU () {
      if (this.bisnisUnit.length === this.bisnisUnit.length) this.selectAllBUApproval = true
      return this.bisnisUnit.length === this.dataBisnisUnit.length
    },
    selectSomeBU () {
      if (this.bisnisUnit.length > 0 && !this.selectAllBU) this.selectAllBUApproval = false
      return this.bisnisUnit.length > 0 && !this.selectAllBU
    },
    iconX () {

      if (this.selectAllBU) return 'close'
      else if (this.selectSomeBU) return 'clear_all'
      else return 'check_box_outline_blank'
    },

    selectAllStatus () {
      return this.e3.length === this.dataStatus.length
    },
    selectSomeStatus () {
      return this.e3.length > 0 && !this.selectAllStatus
    },
    selectAllImType () {
      return this.filterImType.length === this.dataImType.length
    },
    selectSomeImType () {
      return this.filterImType.length > 0 && !this.selectAllImType
    },
    iconXStatus () {
      if (this.selectAllStatus) return 'close'
      else if (this.selectSomeStatus) return 'clear_all'
      else return 'check_box_outline_blank'
    },
    iconXimType () {
      if (this.selectAllImType) return 'close'
      else if (this.selectSomeImType) return 'clear_all'
      else return 'check_box_outline_blank'
    },
    selectAllCategory () {
      return this.category.length === this.dataCategory.length
    },
    selectSomeCategory () {
      return this.category.length > 0 && !this.selectAllCategory
    },
    iconXCategory () {

      if (this.selectAllCategory) return 'close'
      else if (this.selectSomeCategory) return 'clear_all'
      else return 'check_box_outline_blank'
    },
  },
  async created(){

    if (sessionStorage.getItem('hasRefreshed')) {
      sessionStorage.removeItem('hasRefreshed');
    }
    await this.fetchCurrencyConfigs()
  },
  methods: {

    async fetchCurrencyConfigs() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_OLD}/api/currency`)
        this.currencyConfigs = response.data
      } catch (error) {
        console.error('Error fetching currency configurations:', error)
        // Fallback to default configurations...
      }
    },
    isNeedApprovalStatus(item) {
      if (!item) return false;
      const label = (item.imStatusLabel || '').toLowerCase();
      const needApprovalLabel = ((this.i18n.status[9] && this.i18n.status[9].name) || '').toLowerCase();
      if (label && needApprovalLabel && label === needApprovalLabel) {
        return true;
      }
      const statusCode = parseInt(item.imStatus, 10);
      return statusCode === 9;
    },
    getStatusChipColor(item) {
      if (this.isNeedApprovalStatus(item)) {
        const statusEntry = this.i18n.status && this.i18n.status[9];
        return (statusEntry && statusEntry.color) || 'blue';
      }
      const statusEntry = this.i18n.status[item.imStatus];
      return (statusEntry && statusEntry.color) || 'grey';
    },
    getEditRouteName(item) {
      if (!item) return "Edit Memo";
      if (item.imType === 8) return "Edit PV";
      return item.imType == 5 ? "Edit Memo" : item.imType == 6 ? "Edit Memo Payment" : "Edit Memo Announcement";
    },
    //- ...mapMutations([""]),
    isMyNeedReview: function(itemRtDetail) {
      const loginedUserBu = this.$store.state.dataUsers && this.$store.state.dataUsers.user && this.$store.state.dataUsers.user.bu;
      
      if (!loginedUserBu || !itemRtDetail || itemRtDetail.length === 0) {
        return false;
      }

      for(let i in loginedUserBu) {
        //- for(let j in itemRtDetail) {
          if (loginedUserBu[i].id == itemRtDetail[itemRtDetail.length-1].id) {
            return true
          //- }
        }
      }
      return false
    },
    isNeedApprovalForUser(item) {
      if (!item) return false;
      // Prefer text check as requested; fallback to status code 9
      const label = (item.imStatusLabel || "").trim().toLowerCase();
      const needApprovalLabel =
        ((this.i18n.status[9] && this.i18n.status[9].name) || "")
          .trim()
          .toLowerCase();
      if (label && needApprovalLabel && label === needApprovalLabel) return true;
      return parseInt(item.imStatus, 10) === 9;
    },
    createMemo() {
      if (this.createMemoReqType == 'General') {
        //- setCreateMemoRequestType()
        this.$store.commit('setCreateMemoRequestType', "General");
        this.$router.push('/create-memo');
      } else if (this.createMemoReqType == 'Payment') {
        
        //- THERW WILL BE A NEW PAGE CALLED CREATE PAYMENT MEMO SOON
        this.$store.commit('setCreateMemoRequestType', "Payment");
        this.$router.push('/create-payment-memo');
      } else if (this.createMemoReqType == 'Announcement') {
        this.$store.commit('setCreateMemoRequestType', "Announcement");
        this.$router.push('/create-announcement-memo');
      }
    },
    findMemoExport() {
      var date = new Date(this.exportDates);
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1) +1;
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0) +1;
      
      axios({
        method: 'post',
        url: process.env.VUE_APP_API_OLD + `/api/requests/rangedate`,
        data: {dateStart: firstDay, dateEnd: lastDay}
      })
      .then((res) => {

        this.exportFilename = `G-Memo ${firstDay} - ${lastDay}`

        let memoInRangeT = res.data.data

        let result = []
        
        for ( let i in memoInRangeT ) {
          let wf = memoInRangeT[i].imWorkflow
          let useAlias = memoInRangeT[i].imUseAlias
          let Appvs = ""
          let AppvDates = ""

          for (let j in wf) {
            //-  DEFINE ALIAS
            if (useAlias) Appvs += `${wf[j].alias}\n`
            else if (!useAlias)  Appvs += `${wf[j].name}\n`
            else Appvs += `\n`

            //-  DEFINE APPV DATE
            if (wf[j].date) AppvDates += `${wf[j].date}\n`
            else AppvDates += `-\n`
          }

          memoInRangeT[i].Appvs = Appvs.trim()
          memoInRangeT[i].Stat = this.i18n.status[memoInRangeT[i].imStatus].name
          memoInRangeT[i].AppvDates = AppvDates.trim()

          result.push(memoInRangeT[i])
        }

        this.memoInRange = result
      })
      .catch((e)=> {
        console.log(e) 
      })

      //- http://localhost:3004/api/requests/rangedate/2023-04-19/2023-04-26
    },
    //- exportDatesConf() {
    //-   if (this.exportDates[0] > this.exportDates[1]) this.exportDates = [this.exportDates[1], this.exportDates[0]]
    //- },
    async getBisnisUnit() {
      // Prevent multiple simultaneous calls
      if (this.loadingBU) {
        return;
      }
      
      this.loadingBU = true;
      let filteredBU = [];

      // For PV pages, fetch Business Units from API to get accurate is_payment_voucher data
      if (this.title == 'My Request PV' || this.title == 'Approval Page PV') {
        try {
          const token = localStorage.getItem("token");
          const userId = this.$store.state.dataUsers && this.$store.state.dataUsers.user;
          
          // If user data is not available yet, try to get it from store or wait
          if (!userId || !userId._id) {
            // Try fallback to store data first
            const allBU = (this.$store.state.dataUsers && this.$store.state.dataUsers.user && this.$store.state.dataUsers.user.bu) || [];
            if (allBU.length > 0) {
              // For Approval Page PV, show all BU (no is_payment_voucher filter)
              if (this.title == 'Approval Page PV') {
                filteredBU = allBU.filter((val) => {
                  return val && val.business_unit && val.business_unit.id;
                });
              } else {
                filteredBU = allBU.filter((val) => {
                  return val && val.business_unit && val.is_payment_voucher === true && val.business_unit.id;
                });
              }
            } else {
              // If no data available, return early - watcher will retry when user data is available
              this.loadingBU = false;
              return;
            }
          } else {
            // User data is available, fetch from API
            const reqDataBU = await axios.get(
              `${process.env.VUE_APP_API}/users/active/bu/${userId._id}`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            const listBU = reqDataBU.data.data || [];

            // For Approval Page PV, show all active BU (no is_payment_voucher filter)
            if (this.title == 'Approval Page PV') {
              filteredBU = listBU.filter(item => {
                return item.business_unit && 
                       item.business_unit.is_active === true &&
                       item.business_unit.id; // Ensure ID exists
              });
            } else {
              // For My Request PV, filter by is_payment_voucher and is_active (same as CreatePV.vue)
              filteredBU = listBU.filter(item => {
                return item.business_unit &&
                       item.business_unit.is_active === true &&
                       item.is_payment_voucher === true &&
                       item.business_unit.id; // Ensure ID exists
              });
            }
          }
        } catch (error) {
          console.error('Error fetching Business Units:', error);
          // Fallback to store data if API fails
          const allBU = (this.$store.state.dataUsers && this.$store.state.dataUsers.user && this.$store.state.dataUsers.user.bu) || [];

          // For Approval Page PV, show all BU (no is_payment_voucher filter)
          if (this.title == 'Approval Page PV') {
            filteredBU = allBU.filter((val) => {
              return val && val.business_unit && val.business_unit.id;
            });
          } else {
            filteredBU = allBU.filter((val) => {
              return val && val.business_unit && val.is_payment_voucher === true && val.business_unit.id;
            });
          }
        }
      } else {
        // For other pages, use store data
        filteredBU = (this.$store.state.dataUsers && this.$store.state.dataUsers.user && this.$store.state.dataUsers.user.bu) || [];
      }

      // Reset arrays before populating
      if (this.title == 'My IM Request' || this.title == 'My Request PV') {
        this.bisnis_unit = [];
        filteredBU.forEach((val) => {
          // Only add if business_unit exists and has valid id and name
          if (val && val.business_unit && val.business_unit.id && val.business_unit.bu_name) {
            this.bisnis_unit.push({
              text: val.business_unit.bu_name, 
              value: val.business_unit.id
            });
          }
        });
      } else {
        this.bisnis_unit_approval = [];
        filteredBU.forEach((val) => {
          // Only add if business_unit exists and has valid id and name
          if (val && val.business_unit && val.business_unit.id && val.business_unit.bu_name) {
            let dataBu = {
              text: val.business_unit.bu_name,
              value: val.business_unit.id
            };

            let middle = Math.floor(this.bisnis_unit_approval.length / 2);

            this.bisnis_unit_approval.splice(middle, 0, dataBu);

            this.bisnis_unit_approval.reverse()
          }
        });
      }
      
      // Mark as loaded
      this.buLoaded = true;
      this.loadingBU = false;
    },
    EditPage(id){
      this.$router.push(`/memo/edit/${id}`)
    },
    getStatus(data, type, dataWf) {
      if ( type == 'status' ) {

        if(dataWf[0].status == 5) {
            if(data.status == 5) {
              return this.i18n.status[data.status].color;
            }
            return this.i18n.status[1].color;

        } else {
            if ( data.status == undefined ) {
              return this.i18n.status[1].color;
            }
            return this.i18n.status[data.status].color;
        }

      } else if ( type == 'icon' ) {

        if(dataWf[0].status == 5) {
            if(data.status == 5) {
              return this.i18n.status[data.status].icon;
            }
            return

        } else {

          if ( data.status == undefined ) {
            return
          }
          return this.i18n.status[data.status].icon;
        }
      }
    },
    getWithdrawDisplayName(item, workflow) {
      if (!workflow) return 'Unknown';
      const useAlias = item && item.imUseAlias;
      const alias = workflow.alias || workflow.user;
      const name = workflow.name || workflow.user || workflow.alias;
      const selected = useAlias ? (alias || name) : (name || alias);
      return selected || 'Unknown';
    },
    clickColumn(item) {       
      const indexExpanded = this.expanded.findIndex(i => i._id === item._id);
      if (indexExpanded > -1) {
          this.expanded.splice(indexExpanded, 1)
      } else {
            this.expanded.splice(indexExpanded, 1)
            this.expanded.push(item);
      }
    },
    cancel(){
      this.request.cancel()
    },
    getOptions() {
      clearTimeout(this._timerId)
      if(this.request) this.cancel();

      this._timerId = setTimeout(()=>{
        this.$store.state.dataRequests.data = [];
        this.$store.state.dataReqApproval.data = [];
        this.loading = true;
        const search = this.bisnisUnit + "_" + this.e3 + "_" + this.keyword;

        if ( this.options.page == undefined ) {
          this.options.page = 1
        }

        if ( this.options.rowsPerPage == undefined ) {
          this.options.rowsPerPage = this.itemsPerPage
        }
        
        const axiosSource = axios.CancelToken.source()
        this.request = {cancel:axiosSource.cancel}

        if (search.length != 2 && !this.options.sortBy) {
          if (this.title == "Approval Page" || this.title == "Approval Page PV") {
            const currentUserId = this.$store.state.dataUsers && this.$store.state.dataUsers.user && this.$store.state.dataUsers.user._id;
            if (!currentUserId) {
              this.loading = false;
              return;
            }
            let url;
            let config;
            if (this.title == "Approval Page PV") {
              // Build query parameters properly
              const buQuery = this.bisnisUnit.length > 0 ? `&bu=${this.bisnisUnit.join(',')}` : '';
              const statusQuery = this.e3.length > 0 ? `&status=${this.e3.join(',')}` : '';
              const keywordQuery = this.keyword.trim() ? `&keyword=${encodeURIComponent(this.keyword.trim())}` : '';
              url = `${process.env.VUE_APP_API_OLD}/api/pv/approval/${currentUserId}?page=${this.options.page}&perPage=${this.options.rowsPerPage}${buQuery}${statusQuery}${keywordQuery}`
              config = { method: "get", url, cancelToken: axiosSource.token };
            } else {
              url = process.env.VUE_APP_API_OLD + `/api/approval/requests/${currentUserId}/refactor?query=${search.trim()}&page=${this.options.page}&per_page=${this.options.rowsPerPage}`;
              config = { method: "get", url, cancelToken: axiosSource.token, auth: { username: "imemo", password: "Ang3lT3n4n!#" } };
            }
            axios(config)
              .then(res => {
                this.$store.state.dataReqApproval.data = res.data.data;
                this.$store.state.dataReqApproval.jumlah = res.data.jumlah || res.data.total || (res.data.pagination && res.data.pagination.total) || 0;
                this.request=null
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => (this.loading = false));
          } else if (this.title == "My IM Request") {
            //- axios
            //-   .get(
            //-     process.env.VUE_APP_API_OLD + `/api/requests/refactor?_id=${this.$store.state.dataUsers.user._id}&query=${search.trim()}&page=${this.options.page}&per_page=${this.options.rowsPerPage}`,
            //-   )
            //-   .then(res => {
            //-     this.$store.state.dataRequests.data = res.data.data;
            //-     this.$store.state.dataRequests.jumlah = res.data.jumlah;
            //-     this.request=null
            //-   })
            //-   .catch(err => {
            //-       console.log(err)
            //-   })
            //-   .finally(() => (this.loading = false));
          } else if (this.title == "My Request PV") {
            // Use PV-specific endpoint that reads from requests (no JWT dependency)
            const currentUserId = this.$store.state.dataUsers && this.$store.state.dataUsers.user && this.$store.state.dataUsers.user._id;
            if (!currentUserId) {
              this.loading = false;
              return;
            }
            const url = `${process.env.VUE_APP_API_OLD}/api/pv/user/${currentUserId}?query=${search.trim()}&page=${this.options.page}&perPage=${this.options.rowsPerPage}`
            axios({ method: "get", url })
              .then(res => {
                this.$store.state.dataRequests.data = res.data.data || [];
                this.$store.state.dataRequests.jumlah = res.data.total || 0;
                this.request = null;
              })
              .catch(err => { console.log(err) })
              .finally(() => (this.loading = false));
          }
        } else if (this.options.sortBy) {
          const currentUserId = this.$store.state.dataUsers && this.$store.state.dataUsers.user && this.$store.state.dataUsers.user._id;
          if (!currentUserId) {
            this.loading = false;
            return;
          }
          const direction = this.options.sortDesc[0] ? -1 : 1;
          let sortBy = this.options.sortBy;
          if (sortBy[0] == "imNilai") sortBy = "imValue";
          if (sortBy[0] == "imStatusLabel") sortBy = "imStatus";
          if (this.title == "Approval Page" || this.title == "Approval Page PV") {
            if (this.title == "Approval Page PV") {
              // Use PV Approval list endpoint (GET with query params)
              const buQuery = this.bisnisUnit.length > 0 ? `&bu=${this.bisnisUnit.join(',')}` : '';
              const statusQuery = this.e3.length > 0 ? `&status=${this.e3.join(',')}` : '';
              const keywordQuery = this.keyword.trim() ? `&keyword=${encodeURIComponent(this.keyword.trim())}` : '';
              const url = `${process.env.VUE_APP_API_OLD}/api/pv/approval/${currentUserId}?page=${this.options.page}&perPage=${this.options.rowsPerPage}&sortBy=${sortBy[0]}&direction=${direction}${buQuery}${statusQuery}${keywordQuery}`
              axios({ method: "get", url })
                .then(res => {
                  this.$store.state.dataReqApproval.data = res.data.data;
                  this.$store.state.dataReqApproval.jumlah = res.data.total || 0;
                  this.request=null
                })
                .catch(err => {
                  console.log(err)
                })
                .finally(()=>this.loading=false)
            } else {
              let token = localStorage.getItem("token");
              const url = process.env.VUE_APP_API_OLD + `/api/v2/approval/requests/${currentUserId}`;
              const config = {
                method: "post",
                url: url,
                headers: {"Authorization": `Bearer ${token}`},
                data: {
                  "buId": this.bisnisUnit.length > 0  && !this.selectAllBUApproval ? this.bisnisUnit : [],
                  "status": this.e3.length > 0 ? this.e3 : [],
                  "category": this.category.length > 0 ? this.category : [],
                  "direction": direction,
                  "sortBy": sortBy[0],
                  "keyword": this.keyword.trim(),
                  "page": this.options.page,
                  "perPage": this.options.rowsPerPage
                },
              };
              config.data.filterImType = this.filterImType;
              axios(config)
                .then(res => {
                  this.$store.state.dataReqApproval.data = res.data.data;
                  this.$store.state.dataReqApproval.jumlah = res.data.jumlah || (res.data.pagination && res.data.pagination.total) || 0;
                  this.request=null
                })
                .catch(err => { 
                  console.log(err)
                })
                .finally(()=>this.loading=false)
            }
          } else if (this.title == "My IM Request" || this.title == "My Request PV") {
            // THIS ONE
            let token = localStorage.getItem("token");
            const config = {
              method: "post",
              url: process.env.VUE_APP_API_OLD + `/api/v2/requests`,
              headers: {"Authorization": `Bearer ${token}`},
              data: {
                "userId": currentUserId,
                "buId": this.bisnisUnit.length > 0 ? this.bisnisUnit : [],
                "imStatus": this.e3.length > 0 ? this.e3 : [],
                "category": this.category.length > 0 ? this.category : [],
                "direction": direction,
                "sortBy": sortBy[0],
                "keyword": this.keyword.trim(),
                "page": this.options.page,
                "perPage": this.options.rowsPerPage
              },
            };
            // For My Request PV, ensure filterImType includes PV (8)
            if (this.title == "My Request PV") {
              // Switch to PV-specific endpoint (reads from requests with imType 8)
              const url = `${process.env.VUE_APP_API_OLD}/api/pv/user/${currentUserId}?page=${this.options.page}&perPage=${this.options.rowsPerPage}&sortBy=${sortBy[0]}&direction=${direction}&query=${this.bisnisUnit + "_" + (this.e3.length > 0 ? this.e3 : '') + "_" + this.keyword.trim()}`
              axios({ method: "get", url })
                .then(res => {
                  this.page = this.options.page
                  this.$store.state.dataRequests.data = res.data.data || [];
                  this.$store.state.dataRequests.jumlah = res.data.total || 0;
                  this.request=null
                })
                .catch(err => {
                  console.log(err)
                })
                .finally(() => (this.loading = false));
              return;
            } else {
              config.data.filterImType = this.filterImType;
            }
            axios(config)
              .then(res => {
                this.page = this.options.page
                this.$store.state.dataRequests.data = res.data.data || [];
                this.$store.state.dataRequests.jumlah = res.data.jumlah || 0;
                this.request=null
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => (this.loading = false));
          }
        } else if (search.length == 2) {
          if (this.title == "Approval Page") {
            const currentUserId = this.$store.state.dataUsers && this.$store.state.dataUsers.user && this.$store.state.dataUsers.user._id;
            if (!currentUserId) {
              this.loading = false;
              return;
            }
            const config = {
              method: "post",
              url: process.env.VUE_APP_API_OLD + `/api/v2/approval/requests/${currentUserId}`,
              headers: {"Authorization": `Bearer ${token}`},
              data: {
                "buId": this.bisnisUnit.length > 0 ? this.bisnisUnit : [],
                "imStatus": this.e3.length > 0 ? this.e3 : [],
                "category": this.category.length > 0 ? this.category : [],
                "direction": 1,
                "sortBy": sortBy,
                "keyword": search,
                "page": this.options.page,
                "perPage": this.options.rowsPerPage
              },
            };
            config.data.filterImType = this.filterImType,
            axios(config)
            .then(res => {
              //- this.$store.state.dataReqApproval.data = res.data.data;
              //- this.$store.state.dataReqApproval.jumlah = res.data.jumlah;
              this.$store.state.dataReqApproval = { data: res.data.data, jumlah: res.data.jumlah };
              
              this.request=null
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => (this.loading = false));
          } else if (this.title == "My IM Request") {
            //- axios
            //-   .get(
            //-     process.env.VUE_APP_API_OLD + `/api/requests/refactor?_id=${this.$store.state.dataUsers.user._id}&page=${this.options.page}&per_page=${this.options.rowsPerPage}`,
            //-     {
            //-       auth: {
            //-         username: "imemo",
            //-         password: "Ang3lT3n4n!#"
            //-       },
            //-       cancelToken:axiosSource.token
            //-     }
            //-   )
            //-   .then(res => {
            //-     this.$store.state.dataRequests.data = res.data.data;
            //-     this.$store.state.dataRequests.jumlah = res.data.jumlah;
            //-     this.request=null
            //-   })
            //-   .catch(err => {
            //-     console.log(err)
            //-   })
            //-   .finally(() => (this.loading = false));
          }
        }
      },500)
    },
    routeName(val) {
      if ([1, 2, 3].includes(val)) {
        return "Edit IM Budget";
      } else if (val == 4) {
        return "Edit IM Proposal Investasi";
      } else if (val == 5) {
        return "Edit IM General";
      } else if (val == 6) {
        return "Edit IM Announcement";
      } else if (val == 7) {
        return "Edit Document Legal F1";
      } else if (val == 8) {
        return "Edit Document Legal F2";
      } else if (val == 9) {
        return "Edit IM Treasury";
      } else if (val == 10) {
        return "Edit IM Forex";
      } else if (val == 11) {
        return "Edit Internal Memo";
      }
    },
    getUTC7Date(tgl) {
      let tanggal = new Date(tgl);
      let month =
        tanggal.getMonth() + 1 < 10
          ? "0" + (tanggal.getMonth() + 1)
          : tanggal.getMonth() + 1;
      let date =
        tanggal.getDate() < 10
          ? "0" + tanggal.getDate()
          : tanggal.getDate();
      return tanggal.getFullYear() + "-" + month + "-" + date;
    },
    customFilter(items, search, filter) {
      //-MENGGUNAKAN METODE NESTED QUERY
      let hasil = search.split("_");
      //FILTER DARI TIPE
      if (hasil[0]) {
        var jenis = items.filter(i => {
          return !hasil[0] || i.imTypeLabel === hasil[0];
        });
        //UNTUK SEARCH
        if (hasil[2] && (hasil[1] || !hasil[1])) {
          let e4 = hasil[2].toString().toLowerCase();
          var searching = jenis.filter(i =>
            Object.keys(i).some(j => filter(i[j], e4))
          );
          if (hasil[2] && (!hasil[1] || hasil[1])) {
            var status2 = searching.filter(l => {
              return !hasil[1] || l.imStatusLabel === hasil[1];
            });
            return status2;
          }
          return searching;
        }
        //UNTUK STATUS
        if (hasil[1]) {
          var statuslabel = jenis.filter(l => {
            return !hasil[1] || l.imStatusLabel === hasil[1];
          });
          return statuslabel;
        }
        return jenis;
      }
      //FILTER DARI STATUS
      if (hasil[1]) {
        var statusitems = items.filter(l => {
          return !hasil[1] || l.imStatusLabel === hasil[1];
        });
        if (hasil[2] && (hasil[0] || !hasil[0])) {
          let e4 = hasil[2].toString().toLowerCase();
          searching = statusitems.filter(i =>
            Object.keys(i).some(j => filter(i[j], e4))
          );
          if (hasil[2] && (!hasil[0] || hasil[0])) {
            status2 = searching.filter(l => {
              return !hasil[0] || l.imTypeLabel === hasil[0];
            });
            return status2;
          }
          return searching;
        }
        if (hasil[0]) {
          var tipeim = statusitems.filter(l => {
            return !hasil[0] || l.imStatusLabel === hasil[0];
          });
          return tipeim;
        }
        return statusitems;
      }
      //FILTER DARI SEARCH
      if (hasil[2] && (!hasil[1] || hasil[1])) {
        let e5 = hasil[2].toString().toLowerCase();
        var searched = items.filter(i =>
          Object.keys(i).some(j => filter(i[j], e5))
        );
        if (hasil[1]) {
          return searched.filter(l => {
            return !hasil[1] || l.imStatusLabel === hasil[1];
          });
        }
        return searched;
      }

      return items;
    },
    exportExcel(userId) {
      window.open(`${this.API_URL}/api/approval/export/excel/${userId}`);
    },
    isDelivery(imItem) {
      try {
        let result = false;
        if (imItem.imPiNumber) {
          result = true;
        }
        return result;
      } catch (e) {
        return false;
      }
    },
    expandAndRemoveNotif(props) {
      props.expanded = !props.expanded;
    },
    download(imNo) {
      if (!imNo) return;
      this.overlay = true;
      const encodedImNo = encodeURIComponent(imNo);
      const URL = `${process.env.VUE_APP_API}/requests/download_zip/${encodedImNo}`;

      axios.head(URL)
        .then(response => {
          const statusCode = response.status;
          if (statusCode === 404 || statusCode === 500) {
            this.overlay = false;
            this.$toasted.error('Download failed!', { icon : 'error'})
          } else {
            this.overlay = false;
            window.location.href = URL;
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$toasted.error('Download failed!', { icon : 'error'})
        })
    },
    isReviewer(workflow, dataUsers) {
      let result = false;
      let approver = false;
      for (var i = workflow.length - 1; i >= 0; i--) {
        if (workflow[i].status == 3) approver = true;
        if (workflow[i].status == 3 && dataUsers._id == workflow[i].user_id) {
          result = true;
          break;
        }
      }
      if (!approver && i == -1) result = true;
      return result;
    },
    getReviewer(im) {
      let approver = false;
      for (var i = im.imWorkflow.length - 1; i >= 0; i--) {
        if (im.imWorkflow[i].status == 3) return im.imWorkflow[i];
      }
      if (!approver && i == -1) return im.imUser || { id: null };
    },
    toggle () {
      this.$nextTick(() => {
        if (this.selectAllBU) {
          this.bisnisUnit = []
        } else {
          const dta = this.dataBisnisUnit.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.bisnisUnit = result
        }
      })
    },
    toggleImType () {
      if (this.title == "My Request PV") return;
      this.$nextTick(() => {
        // filterImType
        if (this.selectAllImType) {
          this.filterImType = []
        } else {
          const dta = this.dataImType.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.filterImType = result
        }
      })
    },
    toggleStatus () {
      this.$nextTick(() => {
        if (this.selectAllStatus) {
          this.e3 = []
        } else {
          const dta = this.dataStatus.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.e3 = result
        }
      })
    },
    toggleCategory() {
      this.$nextTick(() => {
        if (this.selectAllCategory) {
          this.category = []
        } else {
          const dta = this.dataCategory.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.category = result
        }
      })
    },
    remove(selection, type) {
      const value = Array.isArray(selection) ? selection[0] : selection;
      if (value === undefined || value === null) {
        return;
      }

      if ( type == 'bisnis unit' ) {
        let idx = this.bisnisUnit.indexOf(value)
        if (idx > -1) {
          this.bisnisUnit.splice(idx, 1)
          this.bisnisUnit = [...this.bisnisUnit]
        }

      } else if ( type == 'status' ) {
        let idx = this.e3.indexOf(value)
        if (idx > -1) {
          this.e3.splice(idx, 1)
          this.e3 = [...this.e3]
        }

      } else if ( type == 'category' ) {
        let idx = this.category.indexOf(value)
        if (idx > -1) {
          this.category.splice(idx, 1)
          this.category = [...this.category]
        }

      } else if ( type == 'imType' ) {
        if (this.title == "My Request PV") return;
        let idx = this.filterImType.indexOf(value)
        if (idx > -1) {
          this.filterImType.splice(idx, 1)
          this.filterImType = [...this.filterImType]
        }
      }

      //- 
       
    },
    removeAll(type) {
      if ( type == 'bisnis unit' ) {
        this.bisnisUnit = ''
      } else if ( type == 'status' ) {
        this.e3 = ''
      } else if ( type == 'category' ) {
        this.category = ''
      } else if ( type == 'imType' ) {
        if (this.title == "My Request PV") return;
        this.filterImType = ''
      }
      
    },
  }
};
</script>

<style>

select:required:invalid {
  color: gray;
}
option {
  color: black;
}
.pointer {
  cursor: pointer;
}
</style>
